import { Controller } from "stimulus"

// Types text character-by-character when the element scrolls into view.
// Usage:
//   .element{ data: { controller: "scroll-type", scroll_type_text_value: "Your heading here", scroll_type_speed_value: 25 } }
//     %span{ data: { scroll_type_target: "output" } }

export default class extends Controller {
  static targets = ["output"]
  static values = {
    text: String,
    speed: Number,
    threshold: Number
  }

  connect() {
    this.typed = false
    this.charIndex = 0

    // Create cursor
    this.cursor = document.createElement("span")
    this.cursor.className = "streaming-cursor"
    this.cursor.style.opacity = "0"
    this.outputTarget.after(this.cursor)

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.typed) {
          this.typed = true
          this.cursor.style.opacity = "1"
          this.startTyping()
        }
      })
    }, { threshold: this.hasThresholdValue ? this.thresholdValue : 0.3 })

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.timeout) clearTimeout(this.timeout)
    if (this.cursor && this.cursor.parentNode) this.cursor.remove()
  }

  startTyping() {
    this.type()
  }

  type() {
    if (this.charIndex <= this.textValue.length) {
      this.outputTarget.textContent = this.textValue.substring(0, this.charIndex)
      this.charIndex++
      this.timeout = setTimeout(() => this.type(), this.hasSpeedValue ? this.speedValue : 25)
    } else {
      // Fade out cursor when done
      setTimeout(() => {
        this.cursor.style.transition = "opacity 0.5s ease"
        this.cursor.style.opacity = "0"
      }, 400)
    }
  }
}
